import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../redux/store";
import { fetchSalariesLogAction } from "../redux/actions/salaryMasterLogAction";
import { SalaryMasterLog } from "../types/SalaryMasterLog";
import PageContainer from "../components/custom/PageContainer";
import Main from "../components/custom/Main";
import { StoreState } from "../redux/reducers";
import { useParams } from "react-router-dom";
import { Table } from "react-bootstrap";
import SalaryMasterLogFilter from "../components/SalaryMasterLogFilter";
import CollapseCard from "../components/custom/CollapseCard";
import EmployeeSalaryFilter from "../components/EmployeeSalaryFilter";

const SalaryMasterLogPage = () => {
  const { employeeId } = useParams<{ employeeId: string }>();
  const dispatch = useDispatch<AppDispatch>();

  const allSalaries = useSelector((state: StoreState) => state.salaryMasterLog);
  const [employeeLogs, setEmployeeLogs] = useState<SalaryMasterLog[]>([]);

  const [filters, setFilters] = useState({
    year: "",
    month: "",
    employeeId: "",
  });

  const [filteredLogs, setFilteredLogs] = useState<SalaryMasterLog[]>([]);

  useEffect(() => {
    dispatch(fetchSalariesLogAction());
  }, [dispatch]);

  useEffect(() => {
    if (allSalaries.length && employeeId) {
      const filteredByEmployee = allSalaries.filter(
        (log) => String(log.employeeId) === employeeId,
      );
      setEmployeeLogs(filteredByEmployee);

      setFilters({ year: "", month: "", employeeId: "" });
      setFilteredLogs(filteredByEmployee);
    }
  }, [allSalaries, employeeId]);

  const applyFilters = (newFilters: typeof filters) => {
    setFilters(newFilters);

    const filtered = employeeLogs.filter((log) => {
      const date = new Date(log.createTimestamp);
      const matchesYear =
        !newFilters.year || date.getFullYear().toString() === newFilters.year;
      const matchesMonth =
        !newFilters.month ||
        (date.getMonth() + 1).toString().padStart(2, "0") === newFilters.month;
      const matchesEmployee =
        !newFilters.employeeId || log.employeeId === newFilters.employeeId;
      return matchesYear && matchesMonth && matchesEmployee;
    });

    setFilteredLogs(filtered);
  };

  const handleReset = () => {
    setFilters({ year: "", month: "", employeeId: "" });
    setFilteredLogs(employeeLogs);
  };

  // const dated = employeeLogs.map((log) => {
  //   const date = new Date(log.createTimestamp);
  //   console.log(date);

  //   const year = date.getFullYear();
  //   console.log("year", year);

  //   const month = (date.getMonth() + 1).toString().padStart(2, "0");
  //   console.log("month", month);

  // })

  return (
    <Main>
      <PageContainer title={`Salary Log`}>
        <CollapseCard title="Salary Log Filter">
          <SalaryMasterLogFilter
            filters={filters}
            onFilterChange={applyFilters}
            onReset={handleReset}
          />
        </CollapseCard>

        {filteredLogs.length > 0 ? (
          <Table className="custom-employee-table" responsive>
            <thead>
              <tr>
                <th>S.No</th>
                <th>EmployeeID</th>
                <th>Basic Pay</th>
                <th>HRA</th>
                <th>Tax</th>
                <th>PF</th>
                <th>TA</th>
                <th>SA</th>
                <th>year</th>
                <th>month</th>
              </tr>
            </thead>
            <tbody>
              {filteredLogs.map((log, index) => {
                const date = new Date(log.createTimestamp);
                const year = date.getFullYear();
                const month = (date.getMonth() + 1).toString().padStart(2, "0");

                return (
                  <tr key={log.id}>
                    <td>{index + 1}</td>
                    <td>{log.employeeId}</td>
                    <td>{log.basicPay}</td>
                    <td>{log.hra}</td>
                    <td>{log.tax}</td>
                    <td>{log.pf}</td>
                    <td>{log.ta}</td>
                    <td>{log.sa}</td>
                    <td>{year}</td>
                    <td>{month}</td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        ) : (
          <p>No logs found for this employee.</p>
        )}
      </PageContainer>
    </Main>
  );
};

export default SalaryMasterLogPage;
